module.exports = __webpack_public_path__ + "img/11.2b7f424e.svg";